import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  cs: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}

const CaseStudyItem = ({ cs }) => {
  const { childMarkdownRemark } = cs
  const { frontmatter, fields } = childMarkdownRemark

  const item = {
    id: childMarkdownRemark.id,
    slug: frontmatter.slug,
    title: frontmatter.title,
    summary: frontmatter.summary,
    company: {
      name: frontmatter.company.name,
      logo: fields.companyLogo.publicURL
    },
    isVideo: (frontmatter.video || []).length > 0

  }

  // return <pre>{JSON.stringify(item, null, 2)}</pre>
  return (
      <div className="inner">
        <a href={item.slug}>
          <div className={`resource__image case_study`}>
            {item.company.logo && (
                <img
                    src={item.company.logo}
                    alt={item.company.name}
                />
            )}
            <div className="resource__category">{'CASE STUDY'}</div>
            {item.isVideo &&
                <div className="resource__video">VIDEO</div>
            }
          </div>

          <div className="resource__body">
            <div className="resource__summary">{item.summary}</div>
            <div className="resource__quoter">{item.company.name}</div>
          </div>
        </a>
      </div>
  )
}

CaseStudyItem.propTypes = propTypes

export default CaseStudyItem
